import { TextField } from "@/app/fields";
import { CHARGE_ON } from "@/app/master";
import type { Errors } from "@/app/useDraft";
import { Field, Form, RadioGroup, Switch, Textarea } from "@/ui";
import type { CustomerDraft } from "./customerDraft";

interface Props { draft: CustomerDraft; errors: Errors<CustomerDraft>; set: <K extends keyof CustomerDraft>(k: K, v: CustomerDraft[K]) => void; isNew: boolean; currencyReadOnly?: boolean }

/** 客户表单的字段，见 docs/03 3.1。 */
export function CustomerForm({ draft, errors, set, isNew, currencyReadOnly = false }: Props) {
  return (
    <Form>
      <TextField id="c-name" label="名称" required value={draft.name} error={errors.name} onChange={(v) => set("name", v)} />
      <TextField id="c-currency" label="币种" required mono readOnly={currencyReadOnly} value={draft.currency} error={errors.currency} hint={currencyReadOnly ? "已有账号，记账币种固定" : "客户价格与账单币种，三位代码"} onChange={(v) => set("currency", v.toUpperCase())} />
      <Field label="默认计费方式" required hint="新增客户价格时的默认值；已配置价格按其版本计费类型结算">
        <RadioGroup name="charge_on" value={draft.charge_on} onChange={(v) => set("charge_on", v)} options={[
          { value: "submitted", label: CHARGE_ON.submitted, description: "进入 SUBMITTED 即确认扣费" },
          { value: "delivered", label: CHARGE_ON.delivered, description: "DELIVERED 时确认扣费，FAILED 退回预扣" },
        ]} />
      </Field>
      <TextField id="c-tier" label="档位" required value={draft.tier} hint="路由打分的权重档位" onChange={(v) => set("tier", v)} />
      <Field label="备注" htmlFor="c-note"><Textarea id="c-note" rows={3} value={draft.note} onChange={(e) => set("note", e.target.value)} /></Field>
      {!isNew && <Switch label="启用" checked={draft.status === "active"} onChange={(on) => set("status", on ? "active" : "disabled")} />}
    </Form>
  );
}
